import styles from "../products/analytics-table.module.css"

export default function AlertsTable({ alerts, onAcknowledge, onResolve, onDelete, onViewDetail }) {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Type</th>
              <th>Title</th>
              <th>Status</th>
              <th>Severity</th>
              <th>Priority</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {alerts?.map((alert) => (
              <tr key={alert._id}>
                <td>
                  {alert.color} {alert.alertType}
                </td>
                <td>{alert.title}</td>
                <td className=" uppercase ">{alert.status}</td>
                <td>
                  <span className={alert.severity === "critical" ? styles.warning : ""}>{alert.severity}</span>
                </td>
                <td>{alert.priority}</td>
                <td>{new Date(alert.createdAt).toLocaleString()}</td>
                <td>
                  <div className={styles.actionButtons}>
                    {alert.status === "active" ? (
                      <>
                        <button onClick={() => onAcknowledge(alert._id)}>Ack</button>
                        <button onClick={() => onResolve(alert._id)}>Resolve</button>
                        <button onClick={() => onDelete(alert)}>Delete</button>
                      </>
                    ) : alert.status === "acknowledged" ? (
                        <>
                          <button onClick={() => onResolve(alert._id)}>Resolve</button>
                          <button onClick={() => onDelete(alert)}>Delete</button>
                        </>
                      ) : (
                      <button onClick={() => onDelete(alert)}>Delete</button>
                    )}
                    <button onClick={() => onViewDetail(alert._id)}>Detail</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
